import { useMemo } from "react";

import { debounce, DebouncedFunc, DebounceSettings } from "lodash";

/**
 * Note: debounce doesn't work on Promises. You can't await or `.then` the
 * debounced function.
 */
export default function useDebounce<T extends (...args: any) => any>(
  fn: T,
  wait?: number,
  options?: DebounceSettings
): DebouncedFunc<T> {
  return useMemo(() => debounce(fn, wait, options), []);
}
